<div id="splide" class="splide" [class.disabled]="isLoading">
  <!-- Overlay cuando está cargando -->
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="overlay-spinner"></div>
  </div>
  
  <div class="splide__track">
    <ul class="splide__list">
      <li class="splide__slide" *ngFor="let p of products">
        <div class="product-card" (click)="onProductClick(p)" [class.disabled]="isLoading" [class.selected]="selectedProductIds.has(p.productID)" *ngIf="!p.load">
          <div class="selected-indicator" *ngIf="selectedProductIds.has(p.productID)">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640">
              <path d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"/>
            </svg>
          </div>
          <img [src]="p.image" [alt]="p.name" class="product-image" />
          <h3>{{ p.name }} {{ p.suffix ? p.suffix : '' }}</h3>
          <div class="price">{{ formatPrice(p.price) }}</div>
        </div>
        <div class="product-card" *ngIf="p.load">
          <div class="product-card-loader"></div>
        </div>
      </li>
    </ul>
  </div>
</div>
